import React from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import CopyrightInput from '@/components/common/CopyrightInput';
import { buildCopyrightLine } from '@/components/common/ProductUtilities';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  copyrightYearError: string | undefined;
  copyrightLineError: string | undefined;
  handleAlbumMetaData: (field: string, value: string) => void;
};

export default function CopyrightLineFormGroup({
  album,
  readonly,
  disabled,
  copyrightYearError,
  copyrightLineError,
  handleAlbumMetaData,
  fieldValidationState,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.cLine"
      hasErrors={!!copyrightYearError || !!copyrightLineError}
    >
      <CopyrightInput
        id={'copyrightLine'}
        labelText={t('product.editProduct.cline')}
        linePlaceholderLabelText={t('product.editProduct.copyright_owner')}
        year={album.albumMetaData?.copyrightYear}
        onYearChange={(year) =>
          handleAlbumMetaData('copyrightYear', `${year || ''}`)
        }
        line={album.albumMetaData?.copyrightLine}
        onLineChange={(line) =>
          handleAlbumMetaData('copyrightLine', line || '')
        }
        yearErrorMessage={copyrightYearError}
        lineErrorMessage={copyrightLineError}
        yearValidationState={fieldValidationState?.('CopyrightYear')}
        lineValidationState={fieldValidationState?.('CopyrightLine')}
        displayLineBuilder={buildCopyrightLine}
        readonly={readonly}
        disabled={disabled}
        labelClassName="col-sm-3 form-label"
        inputPairClassName="col-sm-6 pair-input-container padding-left-0"
        errorMessageClassName="col-sm-2 popUp-container"
      />
    </FormGroupWithTooltip>
  );
}
